<ng-dialog-header title="{{ title }}"></ng-dialog-header>
<mat-dialog-content>
  <form [formGroup]="form" class="d-flex flex-md-row flex-column justify-content-between">
    <div class="d-flex flex-column w-100 px-3">
      <p>Norfolk Southern Corporation -
        {{ userInfo ? userInfo.firstName + ' ' + userInfo.lastName : '' }}
        {{ '(' + userInfo?.racf + ')' }}
      </p>
      <mat-form-field appearance="outline">
        <mat-label>* User Email:</mat-label>
        <input matInput formControlName="email" maxlength="120" ngTrim>
        <mat-error [control]="form.controls.email.value" ns-error></mat-error>
      </mat-form-field>
      <ng-container *ngIf="form.controls.location">
        <mat-label ngRequired>* Select Location:</mat-label>
        <mat-radio-group aria-label="Select an option" formControlName="location">
          <mat-radio-button class="w-100" [value]="guarantee.onlineOrigin"><b>NS Origin</b>
            - {{ guarantee.onlineOrigin }}</mat-radio-button>
          <mat-radio-button class="w-100" [value]="guarantee.onlineDestination"><b>NS Destination</b>
            - {{ guarantee.onlineDestination }}
          </mat-radio-button>
          <mat-error *ngIf="form.get('location')?.hasError('required')">
            You must select one item in this group
          </mat-error>
        </mat-radio-group>
      </ng-container>
      <mat-form-field appearance="outline">
        <mat-label>* Enter Reference #:</mat-label>
        <input matInput formControlName="reference" ngTrim [maxLength]="maxReferenceNumberLimit">
        <mat-hint align="end">{{ form.controls.reference.value ? form.controls.reference.value.length : 0}}
          /{{ maxReferenceNumberLimit }}</mat-hint>
        <mat-error [control]="form.controls.reference" ns-error></mat-error>
        <mat-error *ngIf="form.get('reference')?.hasError('eqMaxLength')">
          The limit of characters is {{ maxReferenceNumberLimit }}
        </mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<ng-dialog-footer>
  <div dialog-actions class="d-flex flex-fill align-items-center justify-content-between">
    <div>
         <span *ngIf="form.valid">
             By clicking submit, I guarantee <strong>all charges</strong> for the unit: <strong>{{ this.guarantee.equipmentId }}</strong>
         </span>
    </div>
    <div>
      <button aria-label="Cancel" class="mx-2" color="warn" mat-dialog-close mat-stroked-button>Cancel</button>
      <button (click)="submit()" [disabled]="!form.valid" aria-label="Submit" color="accent" mat-flat-button>
        Submit
      </button>
    </div>
  </div>
</ng-dialog-footer>
